import React from 'react';

import MFormSimpleSelectView from './MFormSimpleSelect.view';

import { MSimpleSelectOption } from 'views/MSimpleSelect/MSimpleSelect.model';
import { MFormFieldProps } from '../../MForm.model';

type Props<OptionValue extends string | number> = MFormFieldProps<[React.ChangeEvent<HTMLSelectElement>], OptionValue | null> & {
  disableDefaultSelect?: boolean;
  options: MSimpleSelectOption<OptionValue>[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
};

const MFormSimpleSelect = <OptionValue extends string | number>(props: React.PropsWithChildren<Props<OptionValue>>): JSX.Element => {
  return (
    <MFormSimpleSelectView
      name={props.name}
      disabled={props.disabled}
      invalid={props.invalid}
      value={props.value}
      options={props.options}
      placeholder={props.placeholder}
      className={props.className}
      onChange={props.onChange}
      onBlur={props.onBlur}
    ></MFormSimpleSelectView>
  );
};

MFormSimpleSelect.displayName = 'MFormSimpleSelect';
MFormSimpleSelect.defaultProps = {};

export default MFormSimpleSelect;
